// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.5 6.75V9.25M4.1 4V11.5M6.7 2V14M9.3 5.5V10M11.9 3.5V12M14.5 6.75V9.25',
];
